var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessage2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 99,
    viewBox: "0 0 99 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1163_309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.5 0H16.5C7.40025 0 0 7.40025 0 16.5V66C0 75.0998 7.40025 82.5 16.5 82.5H28.5574L44.022 95.5226C45.5978 96.921 47.5736 97.614 49.5371 97.614C51.4676 97.614 53.3775 96.9416 54.8666 95.6175L70.7396 82.5H82.5041C91.6039 82.5 99.0041 75.0998 99.0041 66V16.5C99.0041 7.40025 91.5998 0 82.5 0ZM28.875 49.5C25.4595 49.5 22.6875 46.728 22.6875 43.3125C22.6875 39.897 25.4595 37.125 28.875 37.125C32.2905 37.125 35.0625 39.897 35.0625 43.3125C35.0625 46.728 32.2905 49.5 28.875 49.5ZM49.5 49.5C46.0845 49.5 43.3125 46.728 43.3125 43.3125C43.3125 39.897 46.0845 37.125 49.5 37.125C52.9155 37.125 55.6875 39.897 55.6875 43.3125C55.6875 46.728 52.9155 49.5 49.5 49.5ZM70.125 49.5C66.7095 49.5 63.9375 46.728 63.9375 43.3125C63.9375 39.897 66.7095 37.125 70.125 37.125C73.5405 37.125 76.3125 39.897 76.3125 43.3125C76.3125 46.728 73.5405 49.5 70.125 49.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1163_309"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 99,
    height: 99,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage2);
export default __webpack_public_path__ + "static/media/message2.311c56595ad53316303cffd418936830.svg";
export { ForwardRef as ReactComponent };